import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  console.log(STORE_KEY, INITIAL_STATE)
  const appState = state || redux.store.getState();
  console.log(appState?.[STORE_KEY] || INITIAL_STATE)
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectMachineData = state => selectState(state).data;
export const selectedProduct = state => selectState(state).product;
export const getPrinters = state => selectState(state).printersdata;
export const selectMachineLoading = state => selectState(state).loading;
export const selectfetchMachineLoading = state => selectState(state).machineLoading;
export const selectMachineError = state => selectState(state).error;
export const selectMachineFilterVisible = state => selectState(state).filterVisible;
export const selectMachineFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredMachines = createSelector(
  [selectMachineData, selectMachineFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);


